// /* eslint-disable */
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Modal, Button, Upload, Typography, message } from "antd";
import {
  UploadOutlined,
  FileTextOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  NumberOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";

const { Text } = Typography;

const UploadToExcelModal = forwardRef((props, ref) => {
  const { onSuccess } = props;

  const [open, setOpen] = useState(false);
  const [type, setType] = useState("transactions");
  const [errorMsg, setErrorMsg] = useState("");
  const [uploading, setUploading] = useState(false);

  // ------- 上传结果弹窗 -------
  const [resultModalVisible, setResultModalVisible] = useState(false);
  const [resultData, setResultData] = useState(null); // { insertedCount, batchList, msg }

  useImperativeHandle(ref, () => ({
    open: (config = {}) => {
      setType(config.type || "transactions");
      setOpen(true);
    },
    close: () => setOpen(false),
  }));

  const reset = () => {
    setErrorMsg("");
    setUploading(false);
  };

  const handleDownloadInstruction = () => {
    const link = document.createElement("a");
    link.href = "/files/Journal-Entry-Upload-Instruction.docx";
    link.download = "Journal-Entry-Upload-Instruction.docx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

const beforeUpload = async (file) => {
  const isCsv = /\.csv$/i.test(file?.name || "");
  if (!isCsv) {
    message.error("Please upload a CSV file (.csv).");
    return Upload.LIST_IGNORE;
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    setUploading(true);
    setErrorMsg("");

    const res = await http.post(api.getJournalEntryUpload, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res?.code === "1") {
      setErrorMsg("");
      setResultData({
        msg: res?.msg || "Upload successfully.",
        insertedCount: res?.data?.insertedCount ?? 0,
        batchList: res?.data?.batchList || [],
      });
      setResultModalVisible(true);
      onSuccess && onSuccess();
    } else {
      setErrorMsg(res?.msg || "Upload failed.");
    }
  } catch (err) {
    console.log(err);
    setErrorMsg("Upload failed.");
  } finally {
    setUploading(false);
  }

  return false;
};

  const handleCloseResult = () => {
    setResultModalVisible(false);
    setResultData(null);
  };

  const renderResult = () => {
    if (!resultData) return null;

    return (
      <div className="check-result">
        <div className="policy-box">
          <div className="policy-alert valid">
            <CheckCircleOutlined style={{ fontSize: 22, color: "#389e0d" }} />
            <div>
              <div className="alert-title">Upload Successful</div>
              <div className="alert-desc">{resultData.msg}</div>
            </div>
          </div>
        </div>

        <div className="summary">
          <div className="summary-title">Summary</div>

          <div className="summary-cards">
            {/* Inserted Count */}
            <div className="card">
              <div className="card-icon green">
                <FileDoneOutlined style={{ fontSize: 20, color: "#389e0d" }} />
              </div>
              <div className="card-content">
                <div className="card-label">Inserted Entries</div>
                <div className="card-value">{resultData.insertedCount}</div>
              </div>
            </div>

            {/* Batch List */}
            <div className="card">
              <div className="card-icon purple">
                <NumberOutlined style={{ fontSize: 20, color: "#722ed1" }} />
              </div>
              <div className="card-content">
                <div className="card-label">
                  {resultData.batchList.length > 1 ? "Batch Numbers" : "Batch Number"}
                </div>
                <div className="card-value">
                  {resultData.batchList.length > 0
                    ? resultData.batchList.join(", ")
                    : "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        open={open}
        width="60%"
        centered
        destroyOnClose
        maskClosable={false}
        onCancel={() => {
          setOpen(false);
          reset();
        }}
        afterClose={reset}
        footer={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={() => {
                setOpen(false);
                reset();
              }}
            >
              Close
            </Button>
          </div>
        }
        title={null}
      >
        <div
          style={{
            height: "65vh",
            minHeight: 520,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ padding: "14px 16px" }}>
            <div
              style={{
                width: "52%",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <UploadOutlined style={{ color: "#e55353", fontSize: 18 }} />
              <Text style={{ color: "#e55353", fontWeight: 700, fontSize: 18 }}>
                UPLOAD JOURNAL ENTRY TEMPLATE
              </Text>
            </div>
            <div className="model_top"></div>
          </div>

          <div style={{ flex: 1, display: "flex" }}>
            <div style={{ width: "50%" }}>
              <div style={{ padding: 24, height: "100%" }}>
                <Upload
                  accept=".csv"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  disabled={uploading}
                >
                  <Button className="btnNew" loading={uploading}>
                    <UploadOutlined />
                    Upload
                  </Button>
                </Upload>
                {!!errorMsg && (
                  <div
                    style={{
                      marginTop: 16,
                      background: "#d9534f",
                      color: "#fff",
                      padding: "12px 14px",
                      borderRadius: 4,
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <ExclamationCircleOutlined />
                    <span style={{ fontWeight: 600 }}>{errorMsg}</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ width: "50%" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <InfoCircleOutlined style={{ color: "#1677ff", fontSize: 18 }} />
                <Text style={{ fontWeight: 600, fontSize: 16, color: "#666" }}>
                  Information Detail
                </Text>
              </div>

              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 36px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 26, color: "#8c8c8c", lineHeight: 1.3 }}>
                    <br />
                    To Use Upload Journal Entry
                    <br />
                    Please Drag & Drop a CSV File
                  </div>

                  <div
                    style={{
                      marginTop: 24,
                      fontSize: 18,
                      color: "#8c8c8c",
                      lineHeight: 1.6,
                    }}
                  >
                    For the file template and format description of CSV, please click the link below.
                  </div>

                  <div style={{ marginTop: 34 }}>
                    <Button
                      type="primary"
                      size="large"
                      icon={<FileTextOutlined />}
                      onClick={handleDownloadInstruction}
                      style={{
                        height: 56,
                        padding: "0 28px",
                        fontSize: 18,
                        textDecoration: "underline",
                      }}
                    >
                      Download Journal Entry Template
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* 上传结果弹窗 */}
      <Modal
        title="Upload Result"
        open={resultModalVisible}
        onCancel={handleCloseResult}
        maskClosable={false}
        width={600}
        zIndex={2000}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button type="primary" onClick={handleCloseResult}>
              OK
            </Button>
          </div>
        }
      >
        {renderResult()}
      </Modal>
    </>
  );
});

export default UploadToExcelModal;